import React, { forwardRef, useCallback, useEffect, useState } from 'react'
import { Col, Form, Grid, Input, InputGroup, MaskedInput, Row, Text } from 'rsuite'
import FormFieldErrorIcon from './FormFieldErrorIcon'
import { phoneMask } from '../../common/validation';
import { FORM_INPUT_TYPES } from '../../common/enums';

const removePhoneFormatting = (val) => {
    const cleaned = val?.replace(/\D+/g, '');
    return cleaned;
};

const TextInputWithErrorStatus = React.memo(
    forwardRef(
        (
            {
                placeholder,
                showError,
                errorMessage,
                hideErrorIcon,
                value,
                onChange,
                trimStartOnChange,
                trimEndOnChange,
                inputGroupAddOnStart,
                type,
                inputFieldType,
                inputMode,
                preventHtmlValidation,
                ...props
            },
            ref
        ) => {
            const changedInternal = (v) => {
                if (trimStartOnChange) {
                    v = v.trimStart();
                }
                if (trimEndOnChange) {
                    v = v.trimEnd();
                }

                // remove any masks prior to saving to form values
                if (type === FORM_INPUT_TYPES.PHONE) {
                    v = removePhoneFormatting(v);
                }
                onChange(v)
            }

            return (
                <InputGroup {...props} ref={ref}>
                    {inputGroupAddOnStart && (
                        <InputGroup.Addon
                            style={{ backgroundColor: 'white' }}
                        >
                            {inputGroupAddOnStart}
                        </InputGroup.Addon>
                    )}
                    {
                        type === FORM_INPUT_TYPES.PHONE ?
                            <MaskedInput
                                aria-label={`${props.name}-label`}
                                placeholder={placeholder}
                                onChange={changedInternal}
                                value={value}
                                style={{ backgroundColor: 'white' }}
                                mask={phoneMask} />
                            :
                            <Input
                                aria-label={`${props.name}-label`}
                                placeholder={placeholder}
                                onChange={changedInternal}
                                value={value}
                                style={{ backgroundColor: 'white' }}
                                type={inputFieldType}
                                {...(inputFieldType === "textarea" ? { as: 'textarea', rows: 5 } : {})}
                                {...(inputMode ? { inputMode } : {})} 
                                {...(preventHtmlValidation ? { noValidate: true } : {})}
                            />
                    }
                    {!hideErrorIcon && showError && (
                        <InputGroup.Addon
                            style={{ backgroundColor: 'white' }}
                        >
                            <FormFieldErrorIcon errorMessage={errorMessage ?? showError} />
                        </InputGroup.Addon>
                    )}
                </InputGroup>
            )
        }
    )
)

const FormTextField = ({
    name,
    label,
    boldLabel = false,
    subtitle = () => null,
    subtext = () => null,
    inputWidth = null,
    validationRule,
    hasError,
    errorMessage,
    hideErrorIcon = false,
    disabled = false,
    trimStartOnChange = false,
    trimEndOnChange = false,
    inputGroupAddOnStart = undefined,
    bottomMarginOverrideClass = null,
    labelClass = null,
    type = FORM_INPUT_TYPES.TEXT,
    inputFieldType = 'text',
    inputMode = null,
    preventHtmlValidation = false,
    useGridSizing = false,
    ...rest
}) => {
    const TextInputWithErrorStateAndProps = useCallback(
        (props) => (
            <TextInputWithErrorStatus
                {...props}
                showError={hasError}
                errorMessage={errorMessage}
                hideErrorIcon={hideErrorIcon}
                trimStartOnChange={trimStartOnChange}
                trimEndOnChange={trimEndOnChange}
                inputGroupAddOnStart={inputGroupAddOnStart}
                type={type}
                inputFieldType={inputFieldType}
                inputMode={inputMode}
                preventHtmlValidation={preventHtmlValidation}
            />
        ),
        [hasError, errorMessage, hideErrorIcon, trimStartOnChange, trimEndOnChange, inputGroupAddOnStart, preventHtmlValidation, inputFieldType, type, inputMode]
    );

    return (
        <Grid className={bottomMarginOverrideClass} style={{paddingLeft: 0, paddingRight: 0}} fluid>
            <Row>
                <Col xs={24}>
                    {/* <Form.Group controlId={name} className={bottomMarginOverrideClass}> */}
                        {label && label.length > 0 && (
                            <Form.ControlLabel className={labelClass}>
                                <Text className={boldLabel ? "text-bold" : ""}>
                                    {label}
                                </Text>
                            </Form.ControlLabel>
                        )}
                        
                </Col>
            </Row>
            <Row>
                <Col>
                    {subtitle()}
                </Col>
            </Row>
            <Row>
                <Col {...(useGridSizing ? {
                    xs: 24,
                    md: inputFieldType === 'textarea' ? 24 : 12,
                    lg: inputFieldType === 'textarea' ? 24 : 12,
                    xl: inputFieldType === 'textarea' ? 12 : 6
                } : {xs: 24})} >
                    <Form.Control
                        id={undefined} 
                        aria-labelledby={undefined}  
                        aria-describedby={undefined}  
                        style={{ width: inputWidth ?? '100%' }}
                        className={disabled === true ? 'disabled-input' : null}
                        name={name}
                        rule={validationRule}
                        accepter={TextInputWithErrorStateAndProps}
                        disabled={disabled}
                        value={rest.value}
                        {...rest}
                    />
                    {subtext()}
                </Col>
            </Row>

                    {/* </Form.Group> */} 
        </Grid>
    );
};

export default FormTextField
